import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ProductOrder, Customer, Checkout, OnlineOrder, Company } from '../../../shared/models';
import { Money } from '../../../shared/helpers/money';
import { Pix } from '../../../shared/helpers/pix';
import { environment } from '../../../../environments/environment';

import { ApiService } from '../../../shared/services/api.service';
import { CartService } from '../../../shared/services/cart.service';
import { CustomerService } from '../../../shared/services/customer.service';
import { DeliveryService } from '../../../shared/services/delivery.service';
import { PlaceOrderService } from '../../../shared/services/place-order.service';
import { faCheck, faSpinner, faWhatsapp } from '../../../icons';
@Component({
    selector: 'app-checkout',
    templateUrl: './checkout.component.html',
    styleUrls: ['./checkout.component.scss'],
    standalone: false
})
export class CheckoutComponent implements OnInit {
  faSpinner = faSpinner;
  faCheck = faCheck;
  faWhatsapp = faWhatsapp;

  @Input() onlineOrder: OnlineOrder;

  checkout: Checkout;
  needChange: boolean = true;
  errorMsgs: {[field: string]: string} = {};

  trueVal = true;
  falseVal = false;

  company: Company;

  customer: Customer;
  mapOptions = {
    mapType: 'satellite',
    zoom: 18,
    clickableIcons: false
  };
  geoposition: {
    latitude: number,
    longitude: number,
    accuracy: number
  };

  sending: boolean;
  orderId?: number;
  orderEvalCode?: any;
  wappUrl: string = "";

  paymentRestriction: string[];
  pixCopiaCola: string;
  pixCopied: boolean;

  constructor(private cartServ: CartService,
  	private customerServ: CustomerService,
    private deliveryServ: DeliveryService,
    private placeOrderServ: PlaceOrderService,
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService) {

    setTimeout(() => {
      window.scrollTo(0,0);
    }, 80);
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.init();
    }, 200);
  }

  init() {
    this.pixCopied = false;

    if(!this.placeOrderServ.authenticated()) {
      let tries = Number(sessionStorage.getItem('auth_tries') || "0");
      if(tries >= 2) {
        alert("Por favor, informe seus dados novamente");
        this.router.navigate(['../dados-cliente'], {relativeTo: this.route});
      } else {
        sessionStorage.setItem('auth_tries', (tries + 1).toString());
        setTimeout(() => {
          location.reload();
        }, 200);
      }
    } else {
      sessionStorage.setItem('auth_tries', "0");
    }

    this.company = <Company>JSON.parse(localStorage.getItem('current_company'));
    if(this.company) {
      this.paymentRestriction = (this.company.payment_restriction || '').split(',');
    }

    this.customer = this.customerServ.getCustomer();
    this._setGeoposition();

    this.checkout = new Checkout();
    if(this.onlineOrder) {
      OnlineOrder.setAdditionalData(this.onlineOrder);
      this.cartServ.setUseStorage(false);
      this.cartServ.setItems(this.onlineOrder.product_orders);
      this.checkout.paymentType = this.onlineOrder.payment_type;
      this.checkout.changeNeeded = this.onlineOrder.change_needed;
      if(this.onlineOrder.delivery_fee && (Number(this.onlineOrder.delivery_fee) > 0)) {
        this.checkout.delivery_fee = Number(this.onlineOrder.delivery_fee);
      }
    } else {
      this.checkout.paymentType = 'cash';
      this.checkout.items = this.cartServ.getItems();
      if(this.checkout.items.length == 0)
        this.goMenu();
      
      let possibleChange = Money.possibleChange(this.checkout.total, 50);
      if(possibleChange == this.checkout.total)
        this.needChange = false;
      else
        this.checkout.changeNeeded = possibleChange;
    }

    if(this.customer.address)
      this.checkout.selectedDistrictObj = this.deliveryServ.getSelectedDistrictObj();
    
    this._recalculateValues();
  }

  ngOnDestroy() {
    if(this.onlineOrder) {
      this.cartServ.clear();
      this.cartServ.setUseStorage(true);
    }
  }

  goMenu() {
    this.router.navigate([".."], {relativeTo: this.route});
  }
  goBack() {
    this.router.navigate(["../carrinho"], {relativeTo: this.route});
  }
  goToCustomerDetails(event) {
    event.preventDefault();

    this.router.navigate(["../dados-cliente"], {relativeTo: this.route});
  }

  checkPix() {
    this.pixCopied = false;

    if(this.checkout.paymentType == 'pix')
      this.pixCopiaCola = this._generatePixCopiaCola();
  }
  copyPixCopiaCola() {
    let el: any = document.getElementById('pix-copia-cola');
    el.select();
    document.execCommand('copy');
    this.pixCopied = true;
    this.placeOrder();
    document.getElementById("concluir").scrollIntoView({behavior: 'smooth'});
  }

  placeOrder() {
    if(this.sending)
      return;

    if(this._missingDistrict()) {
      alert("Não conseguimos confirmar o bairro de entrega. Por favor, selecione o bairro novamente.");
      this.deliveryServ.clearSelectedDistrict();
      this.router.navigate(['../dados-cliente'], {relativeTo: this.route});
      return;
    }

    if(this._validInfo()) {
      this.sending = true;

      this.placeOrderServ.send(this.checkout).subscribe(
        res => {
          this.orderId = res.online_order.id;
          this.orderEvalCode = res.online_order.eval_code;
          this._genWappUrl();
          //alert("Pedido enviado! Por favor aguarde a confirmação do estabelecimento.");
          //this.router.navigate(['../meus-pedidos'], {relativeTo: this.route});
        },
        err => {
          this.sending = false; // add here too just in case
          alert("Erro ao enviar pedido! Por favor contate o estabelecimento");
          console.log(err);
        },
        () => {this.sending = false;}
      );
    }
  }

  openWapp() {
    if(this.wappUrl) window.open(this.wappUrl, '_blank', 'noopener,noreferrer');

    setTimeout(() => {
      this.router.navigate(['..', 'meus-pedidos'], {relativeTo: this.route});
    }, 5000);
  }
  dontOpenWapp() {
    this.router.navigate(['..', 'meus-pedidos'], {relativeTo: this.route});
  }

  private _setGeoposition() {
    let coords = this.customer.coords;

    if(coords) {
      this.geoposition = {
        accuracy: Number(coords.split("lat=")[0].split("acc=")[1]),
        latitude: Number(coords.split("lat=")[1].split("long=")[0]),
        longitude: Number(coords.split("long=")[1])
      };
    }
  }

  private _recalculateValues() {
    this.checkout.subtotal = this.cartServ.getTotal();
    this.checkout.prettySubtotal = this.cartServ.getPrettyTotal();
    if(!this.checkout.delivery_fee) {
      this.checkout.delivery_fee = 0;
    }
    this.checkout.prettyDeliveryFee = 'CALCULANDO';
    if(this.checkout.selectedDistrictObj) {
      this.checkout.delivery_fee = Number(this.checkout.selectedDistrictObj.valor.replace(',','.'));
      this.checkout.prettyDeliveryFee = this.checkout.selectedDistrictObj.valor;
    } else if(this.customerServ.getMode() == 'pickup') {
      this.checkout.prettyDeliveryFee = '0,00 (virá buscar)';
    }

    this.checkout.total = this.checkout.subtotal + this.checkout.delivery_fee;
    this.checkout.prettyTotal = this.checkout.total.toFixed(2).replace('.',',');

    this.checkout.customer = this.customerServ.getCustomer();
  }

  private _genWappUrl() {
    if(!this.orderId) {
      console.error("CheckoutComponent::genWappUrl -> no valid ID for online order");
      alert("Erro ao gerar mensagem whatsapp");
      return;
    }
    const ref = this._shortRef(this.orderEvalCode);
    const phone = environment.ncommerce_wapp;
    let msg = `Olá, meu nome é ${this.customer.name} e fiz um *PEDIDO* (id: ${this.orderId}) e gostaria de acompanhar o andamento!${ref}`;
    const encodedMsg = encodeURIComponent(msg);
    this.wappUrl = `https://wa.me/${phone}?text=${encodedMsg}`;
  }

  private _shortRef(code?: string): string {
    if(!code || String(code).length < 5) {
      return '';
    }
    const raw = String(code);
    return `\n\n(ref: ${raw.substr(0, 3)}-${raw.substr(3, 2)})`;
  }

  private _missingDistrict(): boolean {
    if(this.customerServ.getMode() != 'delivery')
      return false;

    let d = this.checkout.selectedDistrictObj;
    return !d || !d.bairro || d.bairro.length == 0 || !d.valor;
  }

  private _validInfo() {
    this.errorMsgs = {};
    if(this.checkout.paymentType == 'cash') {
      if(this.needChange){
        if(this.checkout.changeNeeded < this.checkout.total){
          this.errorMsgs['change'] = "Por favor, peça troco para um valor maior que o valor da conta";
        }
      } else {
        this.checkout.changeNeeded = null;
      }
    } else {
      this.needChange = false;
      this.checkout.changeNeeded = null;
    }

    return JSON.stringify(this.errorMsgs) == "{}";
  }

  private _generatePixCopiaCola() {
    if(!this.company.pix_info) {
      return null;
    }
    let pixInfo = JSON.parse(this.company.pix_info);
    let pixObj = new Pix(pixInfo.key, 
                     this.customer.name.replace(/[^a-zA-Z ]/g, ""), 
                     pixInfo.name, 
                     pixInfo.city,
                     this.customer.phone,
                     Number(this.checkout.total));
    return pixObj.getPayload();
  }

}
